import { create } from 'apisauce';

const WebApiBand = create({
  baseURL: process.env.REACT_APP_BAND_API_URL,
  timeout: 120000
});

const handleResponse = response => {
  if (!response.ok) throw response;
};

WebApiBand.addResponseTransform(handleResponse);

export default WebApiBand;
